/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ExceptionData } from './ExceptionData';
import {
    ExceptionDataFromJSON,
    ExceptionDataFromJSONTyped,
    ExceptionDataToJSON,
} from './ExceptionData';

/**
 * 
 * @export
 * @interface Exception
 */
export interface Exception {
    /**
     * 
     * @type {string}
     * @memberof Exception
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Exception
     */
    readonly message?: string | null;
    /**
     * 
     * @type {ExceptionData}
     * @memberof Exception
     */
    data?: ExceptionData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Exception
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Exception
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Exception
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Exception
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Exception
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Exception
     */
    $type?: ExceptionTypeEnum;
}


/**
 * @export
 */
export const ExceptionTypeEnum = {
    SystemExceptionSystemPrivateCoreLib: 'System.Exception, System.Private.CoreLib'
} as const;
export type ExceptionTypeEnum = typeof ExceptionTypeEnum[keyof typeof ExceptionTypeEnum];



/**
 * Check if a given object implements the Exception interface.
 */
export function instanceOfException(value?: unknown): value is Exception {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ExceptionTypeEnum)[0];
}

export function ExceptionFromJSON(json: any): Exception {
    return ExceptionFromJSONTyped(json, false);
}

export function ExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Exception {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ExceptionDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ExceptionToJSON(value?: Omit<Exception, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': ExceptionDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        '$type': value['$type'],
    });
}

